var _filter, _circle, _path, _circle2, _circle3, _circle4, _text, _text2, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTitleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 600,
    height: 120,
    viewBox: "0 0 600 120",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "titleGradient",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#667eea",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    style: {
      stopColor: "#764ba2",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#f093fb",
      stopOpacity: 1
    }
  })), _filter || (_filter = /*#__PURE__*/React.createElement("filter", {
    id: "glow"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "coloredBlur"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 35,
    fill: "url(#titleGradient)",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 45 Q40 35 50 35 Q60 35 60 40 Q70 40 80 45 Q80 55 75 65 Q70 75 60 80 Q50 80 40 75 Q35 65 35 55 Q35 45 40 45 Z",
    fill: "url(#titleGradient)",
    filter: "url(#glow)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 3,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 65,
    cy: 55,
    r: 2,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 55,
    cy: 65,
    r: 2,
    fill: "white"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 45,
    fontFamily: "Arial, sans-serif",
    fontSize: 32,
    fontWeight: "bold",
    fill: "url(#titleGradient)",
    filter: "url(#glow)"
  }, "\n    AI Chatbot\n  ")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 110,
    y: 70,
    fontFamily: "Arial, sans-serif",
    fontSize: 16,
    fontWeight: 300,
    fill: "#666",
    opacity: 0.8
  }, "\n    Powered by Amazon Bedrock\n  ")), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 30,
    r: 4,
    fill: "url(#titleGradient)",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 540,
    cy: 45,
    r: 2,
    fill: "url(#titleGradient)",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 560,
    cy: 35,
    r: 3,
    fill: "url(#titleGradient)",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitleLogo);
export default __webpack_public_path__ + "static/media/title-logo.e80fb2bd944e2c4f0e3dedff6edccf35.svg";
export { ForwardRef as ReactComponent };